import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import SystemDown from '../../components/SystemDown/SystemDown';

function WithSystemDownCheckRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!rest.isByPassMaintenanceMode && rest.systemStatus.isSystemDown) {
          return <SystemDown restoreDate={rest.systemStatus.restoreDate} />;
        }

        return <Component {...props} {...rest.componentProps} />;
      }}
    />
  );
}

WithSystemDownCheckRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};

const mapStateToProps = ({ global }) => ({
  systemStatus: global.systemStatus,
  isByPassMaintenanceMode: global.isByPassMaintenanceMode,
});

export default connect(mapStateToProps)(WithSystemDownCheckRoute);
